import { GRADE_META, LISTABLE_GRADES } from './usedPartGrades';

/** Mandatory evidence shots for shelf-stock camera listing (Mode C/D). */
export const LISTING_SHOTS = [
  {
    id: 'full_view',
    label: 'Full view',
    guidance: 'Show the entire part — all sides visible in frame',
    shortHint: 'All sides visible',
  },
  {
    id: 'label',
    label: 'Label / part number',
    guidance: 'Close-up of part number, label, or casting mark',
    shortHint: 'Part number close-up',
  },
  {
    id: 'damage',
    label: 'Worst damage',
    guidance: 'Worst visible damage, scratch, or wear on the part',
    shortHint: 'Worst wear or damage',
  },
  {
    id: 'functional',
    label: 'Functional surfaces',
    guidance: 'Connection points, mating surfaces, or functional areas',
    shortHint: 'Connections & surfaces',
    gradeCOnly: true,
  },
];

export function minPhotosForGrade(grade) {
  return GRADE_META[grade]?.minPhotos ?? 3;
}

export function shotsForGrade(grade) {
  const g = LISTABLE_GRADES.includes(grade) ? grade : 'B';
  const min = minPhotosForGrade(g);
  if (min >= 4) return LISTING_SHOTS;
  return LISTING_SHOTS.filter((s) => !s.gradeCOnly);
}

export function canUseCameraFirstListing(user) {
  const mode = user?.usedSellerDetails?.sellerMode;
  const tools = user?.usedSellerDetails?.dashboardTools || [];
  return mode === 'D' || mode === 'C' || tools.includes('single_part_upload');
}
